<app-table
    [items]="store.items()"
    [columns]="columns"
    [tableTitle]="(prefix + 'title') | translate"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    [rowExpansion]="rowExpansion"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
>
    <ng-template pTemplate="included" let-data="data">
        <app-check-or-cross [value]="data"></app-check-or-cross>
    </ng-template>

    <ng-template #rowExpansion let-item="item">
        <app-organization-settings-vat-code-line [vatCodeId]="item.id"></app-organization-settings-vat-code-line>
    </ng-template>
</app-table>
